import { Container } from "@mui/material"
import { Datagrid, DateField, List, TextField } from "react-admin"

export const PrintLog = () => {
    return (
        <Container>
            <List resource='PrintLogs'>
                <Datagrid>
                    <TextField source='orderId' />
                    <TextField source='orderType' />
                    <TextField source='label' />
                    <TextField source='user' />
                    <DateField source='createdAt' label='Printed' />
                </Datagrid>
            </List>
        </Container>

    )
}